module.exports = __webpack_public_path__ + "static/media/vertical-slide-1.87d62c48.jpg";